(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('StatusService', StatusService);

  StatusService.$inject = ['$resource'];

  function StatusService ($resource) {
    return $resource(apiUrl + '/statuses/:id', { id: '@id' }, {
      getConfigs: { url: apiUrl + '/statuses-config', method: 'GET', isArray: false },
      update: { method: 'PUT' },
      all: { method: 'GET', isArray: true },
      classification_statuses: { url: apiUrl + '/classification-statuses', method: 'GET', isArray: true },
      should_close_statuses: { url: apiUrl + '/should-close-statuses', method: 'GET', isArray: true },
      setDefault: { url: apiUrl + '/statuses/set-deafult', method: 'POST', isArray: false },
      remove: { method: 'DELETE', isArray: false },
      statuses_with_trashed: { url: apiUrl + '/statuses-with-trashed', method: 'GET', isArray: true },
      change_position: { url: apiUrl + '/change-position', method: 'POST', isArray: false },
      possible_parent_statuses: { url: apiUrl + '/parent-statuses', method: 'POST', isArray: false },
      menu_statuses: { url: apiUrl + '/menu-statuses', method: 'POST', isArray: true },
      allForProfileConfig: { url: apiUrl + '/statuses/all-for-profile-config', method: 'GET', isArray: true }
    });
  }
})();
